import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromApiKey from './+state/api-key/api-key.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ApiKeyEffects } from './+state/api-key/api-key.effects';
import { GoogleAccountClientService } from './google-account/google-account-client.service';
import { GoogleAccountEffects } from './+state/google-account/google-account.effects';
import { GoogleAccountFacade } from './google-account/google-account.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromApiKey.apiKeyFeatureKey, fromApiKey.reducer),
    EffectsModule.forFeature(ApiKeyEffects),
    EffectsModule.forFeature([GoogleAccountEffects]),
  ],
  providers: [GoogleAccountClientService, GoogleAccountFacade],
})
export class WorkspaceSettingsDomainModule {}
